import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
/* eslint-disable no-undef */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
//import '../plugins/vuetify' //forse non necessario su ogni componente
import _ from "lodash";
import hideMobileKeyboardOnReturn from "../plugins/utils";
import ItemsCarousel from "./ItemsCarousel.vue";
import config from "@/config/custom-config";
let Frontali = class Frontali extends Vue {
  constructor() {
    super(...arguments);
    this.element = {
      title: "Forma",
      subtitle: "Scegli la forma frontale"
    };
    this.itemsType = "frontali";
    this.open = false;
    this.query = "";
    this.frontModelActive = null;
    this.selectedSize = null;
    this.animateSize = false;
    this.noSizeSelectedDialog = false;
    this.previousSize = "";
    this.showSunModelNotAvailable = false;
    this.activeElement = null;
    this.selectedType = [];
    this.scrolling = false;
    this.showLeftButton = false;
    this.showRightButton = true;
    this.scrollCounter = 0;
    this.frontTypeOptions = [{
      text: "Vista",
      id: "V"
    }, {
      text: "Sole",
      id: "S"
    }];
    this.macCount = 0;
    this.currentScrollPosition = 0;
    this.selectedShape = null;
  }
  mounted() {}
  get marchio() {
    return this.$store.state.marchio;
  }
  get availableShapes() {
    let shapes = this.items.map(item => item.U_THE_SHAPE);
    const uniqueShapes = Array.from(new Set(shapes)).filter(Boolean);
    return uniqueShapes.map(shape => {
      return {
        text: this.Shapesname[shape] || shape,
        id: shape
      };
    }).sort((a, b) => a.text.localeCompare(b.text));
  }
  set marchio(value) {
    this.$store.commit("setMarchio", value);
  }
  get config() {
    return config;
  }
  get activeModelCode() {
    this.activeElement = this.$store.state.configurator.frontale;
    const frontale = this.$store.state.configurator.frontale;
    if (frontale) {
      return frontale.ItemCode;
    } else {
      console.warn("frontale is null or undefined");
      return null;
    }
  }
  set activeModelCode(value) {
    if (value) {
      this.setFrontal(value);
    }
  }
  get btActive() {
    return this.$store.state.btActive;
  }
  set btActive(value) {
    this.$store.state.btActive = value;
  }
  get lineNames() {
    let items = this.$store.state.configurator.frontali.items;
    return items.map(item => {
      return {
        title: item.U_THE_LINEA,
        value: item.U_THE_LINEA
      };
    });
  }
  get selectedFrontType() {
    return this.$store.state.configurator.glassType;
  }
  set selectedFrontType(val) {
    this.$store.commit("configurator/setLensesType", val, {
      root: true
    });
    // Check whether the corresponding version in the new type is actually available
    // If not, reset the frontal model to null
    // If the selected model is sun, check whether the sun version is actually available
    if (val == "S") {
      const filtered = this.items.filter(i => {
        return i.U_THE_CUSMODEL == "C" && i.U_TIPO_VSP == "S";
      });
      // If the corresponding sun model is not found, show an error to the user and bring him back to sight models
      if (filtered.find(f => {
        return f.U_THE_MODELLO == this.frontale.U_THE_MODELLO.replaceAll("C", "SC");
      }) == undefined) {
        this.showSunModelNotAvailable = true;
        return;
      }
    }
    this.$store.commit("setLenteDx", null);
    this.$store.commit("setLenteSx", null);
    this.$store.commit("resetLentiVista");
    this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
    this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
    // this.$store.commit("resetRowNotes");
  }
  get itemSizesWithFormattedSize() {
    return this.itemSizes.map(item => ({
      ...item,
      formattedSize: `${item.size_eye}/${item.size_bridge}`
    }));
  }
  get Shapesname() {
    const map = {
      "ROUND": this.$t('message.Rotonda'),
      "GEOMETRIC": this.$t('message.Geometrica'),
      "CAT-EYE": "Cat-Eye",
      "RECTANGLE": this.$t('message.Rettangolare')
    };
    return map;
  }
  get formattedItemSizes() {
    const sizeDescMap = {
      "SMALL": "Piccolo",
      "MEDIUM": "Medio",
      "LARGE": "Grande"
    };
    return this.itemSizes.map(item => {
      var _item$size_descriptio;
      return {
        text: `${parseInt(item.size_eye, 10)}-${parseInt(item.size_bridge, 10)} - (${sizeDescMap[(_item$size_descriptio = item.size_description) === null || _item$size_descriptio === void 0 ? void 0 : _item$size_descriptio.toUpperCase()] || item.size_description})`,
        id: item.id
      };
    });
  }
  get calibro() {
    const parsed = parseInt(this.$store.state.configurator.calibro);
    return isNaN(parsed) ? 0 : parsed;
  }
  get naso() {
    const parsed = parseInt(this.$store.state.configurator.naso);
    return isNaN(parsed) ? 0 : parsed;
  }
  get frontale() {
    return this.$store.state.configurator.frontale;
  }
  get user() {
    return this.$store.state.configurator.user.user;
  }
  get sizes() {
    return this.$store.state.configurator.frontali.itemsSizes;
  }
  get items() {
    return this.$store.state.configurator.frontali.items;
  }
  get asianFitting() {
    return this.$store.state.configurator.asianFitting;
  }
  set asianFitting(af) {
    this.$store.commit("configurator/setAsianFitting", af);
  }
  get elementTitle() {
    return _.upperCase(this.element.title);
  }
  get filteredItems() {
    //voglio invertire gli items in base a come sono il primo sarà l'ultimo
    var query = this.query;
    let sortedItems = this.items.sort((a, b) => {
      return a.U_THE_LINEA.localeCompare(b.U_THE_LINEA);
    });
    let itemsReverse = sortedItems.reverse();
    let fData = itemsReverse;
    if (this.selectedShape) {
      fData = fData.filter(item => item.U_THE_SHAPE === this.selectedShape);
    }
    if (this.query && this.query != "" && fData) {
      return fData.filter(function (item) {
        return _.includes(item.U_THE_MODELLO, query);
      });
    }
    this.itemsLoaded = fData.length > 0;
    return fData;
  }
  get itemsLoaded() {
    return this.$store.state.itemsLoaded;
  }
  set itemsLoaded(value) {
    if (this.items.length > 0) {
      this.$store.commit("setItemsLoaded", value);
    }
  }
  get itemSizes() {
    let front = this.frontale;
    if (front && this.sizes.length > 0) {
      return this.sizes.filter(function (s) {
        return s.U_THE_MODELLO == front.U_THE_MODELLO;
      });
    }
    return [];
  }
  get finitura() {
    return this.$store.state.finitura;
  }
  set finitura(f) {
    this.$store.commit("configurator", "setFinishing", f);
  }
  get asianFittingText() {
    return this.asianFitting ? "YES " + this.$t("message.Asian_fitting") : "NO " + this.$t("message.Asian_fitting");
  }
  selectSizeFromSizes() {
    const s = this.itemSizes.filter(is => {
      var _this$frontale;
      return is.ItemCode == ((_this$frontale = this.frontale) === null || _this$frontale === void 0 ? void 0 : _this$frontale.ItemCode) && parseInt(is.size_eye) == this.calibro && parseInt(is.size_bridge) == this.naso;
    });
    if (s.length > 0) {
      this.selectedSize = s[0].id;
    }
  }
  async setFrontal(value) {
    var _this$frontale2;
    if (value && ((_this$frontale2 = this.frontale) === null || _this$frontale2 === void 0 ? void 0 : _this$frontale2.U_THE_SOTTOLINEA) != value.U_THE_SOTTOLINEA) {
      // Reset materiale
      this.$store.commit("configurator/setTemplesMaterial", "PL");
      // Reset colors
      await this.$store.dispatch("configurator/frontali/setColor", "EP0001");
      await this.$store.dispatch("configurator/aste/setColor", "EP0001");
      // Reset finishing to Shiny
      this.$store.commit("configurator/setFinishing", "S");
      this.$store.commit("configurator/setTemplesFinishing", "S");
    }
    if (value) {
      this.$store.commit("configurator/setFrontal", value);
    }
  }
  setSize(value) {
    this.$store.commit("configurator/setSize", value);
  }
  clearSize() {
    this.$store.commit("configurator/setSize", {
      size_eye: "",
      size_bridge: ""
    });
  }
  setAsianFitting(value) {
    this.$store.commit("configurator/setAsianFitting", value);
  }
  setSunLensesModel(value) {
    this.$store.commit("configurator/setSunLensesModel", value);
  }
  hideMobileKeyboardOnReturn(e) {
    hideMobileKeyboardOnReturn(e);
  }
  async setFrame(item) {
    var _this$activeElement;
    if (((_this$activeElement = this.activeElement) === null || _this$activeElement === void 0 ? void 0 : _this$activeElement.U_THE_LINEA) != item.U_THE_LINEA) {
      this.$emit("reset-configuration");
    }
    await this.setFrontal(item);
    if (this.selectedSize) {
      this.selectedSize = null;
      this.clearSize();
    }
    if (item.U_THE_LINEA == "BT") {
      this.btActive = true;
    } else {
      this.btActive = false;
    }
  }
  tipoChanged(newVal) {
    this.setSunLensesModel(null);
    const m = this.filteredItems.filter(i => {
      return i.U_THE_MODELLO.replace("SC", "").replace("C", "") == this.frontale.U_THE_MODELLO.replace("SC", "").replace("C", "") && i.U_TIPO_VSP == newVal;
    });
    if (m.length > 0) {
      // this.setFrontal(m[0]);
      this.$store.state.configurator.frontale == m;
      this.activeModelCode = m[0];
    }
    if (this.calibro && this.naso) {
      const s = this.itemSizes.filter(is => {
        return is.ItemCode == m[0].ItemCode && parseInt(is.size_eye) == this.calibro && parseInt(is.size_bridge) == this.naso;
      });
      if (s.length > 0) {
        this.setSize(s[0]);
      }
    }
  }
  async onMarchioChanged(newVal) {
    if (newVal) {
      this.currentScrollPosition = 0;
      if (this.filteredItems.length > 0) {
        if (this.filteredItems && this.filteredItems.length > 0) {
          await this.setFrontal(this.filteredItems[0]); // Imposta il primo elemento se esiste
        } else {
          console.log("nessun modello filtrato");
        }
      } else {
        console.log("nessun modello filtrato");
      }
    }
  }
  onSelectedSizeChanged(newVal) {
    let s = this.itemSizes.filter(s => {
      return s.id == newVal;
    });
    if (s.length > 0) {
      const foundSize = this.sizes.find(el => {
        var _this$frontale3;
        return el.U_THE_MODELLO == ((_this$frontale3 = this.frontale) === null || _this$frontale3 === void 0 ? void 0 : _this$frontale3.U_THE_MODELLO) && Number(el.size_eye) == this.calibro && Number(el.size_bridge) == this.naso;
      });
      this.previousSize = foundSize == undefined ? null : foundSize.id;
      this.setSize(s[0]);
      this.noSizeSelectedDialog = false;
    } else {
      this.clearSize();
    }
  }
  onRevealSettingChanged(newVal) {
    //add animation class to element
    let self = this;
    if (newVal == "frontSize") {
      this.animateSize = true;
      setTimeout(function () {
        self.animateSize = false;
        self.$emit("reset-setting-item");
      }, 2000);
    }
    if (newVal == "frontSize") {
      this.animateSize = true;
      setTimeout(function () {
        self.animateSize = false;
        self.$emit("reset-setting-item");
      }, 2000);
    }
  }
  onStepperChangeChanged(newVal) {
    if (newVal[0] == 1 && this.calibro == 0) {
      //change from step 1
      this.noSizeSelectedDialog = true;
    }
  }
  onCalibroChanged() {
    if (this.naso) {
      this.selectSizeFromSizes();
    }
  }
  onNasoChanged() {
    if (this.calibro) {
      this.selectSizeFromSizes();
    }
  }
  onItemSizesChanged() {
    if (this.calibro && this.naso) {
      this.selectSizeFromSizes();
    }
  }
};
__decorate([Prop({
  default: false
})], Frontali.prototype, "isOpen", void 0);
__decorate([Prop({
  default: false
})], Frontali.prototype, "revealSetting", void 0);
__decorate([Prop({
  default: false
})], Frontali.prototype, "darkTheme", void 0);
__decorate([Prop()], Frontali.prototype, "stepperChange", void 0);
__decorate([Prop()], Frontali.prototype, "defaultFrontalModel", void 0);
__decorate([Watch("selectedFrontType")], Frontali.prototype, "tipoChanged", null);
__decorate([Watch("marchio")], Frontali.prototype, "onMarchioChanged", null);
__decorate([Watch("selectedSize")], Frontali.prototype, "onSelectedSizeChanged", null);
__decorate([Watch("revealSetting")], Frontali.prototype, "onRevealSettingChanged", null);
__decorate([Watch("stepperChange")], Frontali.prototype, "onStepperChangeChanged", null);
__decorate([Watch("calibro")], Frontali.prototype, "onCalibroChanged", null);
__decorate([Watch("naso")], Frontali.prototype, "onNasoChanged", null);
__decorate([Watch("itemSizes")], Frontali.prototype, "onItemSizesChanged", null);
Frontali = __decorate([Component({
  components: {
    ItemsCarousel
  },
  filters: {
    capitalize: function (value) {
      return _.capitalize(value);
    }
  }
})], Frontali);
export default Frontali;